import { getUserEmail, getUserFullName } from "@faire/help-center-utils/serialized-data/getUser";
import { QueryParameters as EmailQueryParameters } from "@faire/web-api/routes/support/self-serve/email";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { useIssuePlaceholder } from "./useIssuePlaceholder";
import { useScrollToTopOnLoadEffect } from "./useScrollToTopEffect";
import { useSelectedOrderNumber } from "./useSelectedOrderNumber";
export var useInitializeEmailField = function useInitializeEmailField() {
  var userFullName = getUserFullName();
  var emailAddress = getUserEmail();
  var queryParams = useQueryParams(EmailQueryParameters.parse);
  var selectedOrderNumber = useSelectedOrderNumber();
  var issuePlaceholder = useIssuePlaceholder();
  useScrollToTopOnLoadEffect(10);
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var prefilledDescriptionMessage = strictLocalize({
    id: "wYBZgr",
    defaultMessage: [{
      "type": 0,
      "value": "{Message prérempli}"
    }]
  }) + "\n" + strictLocalize({
    id: "uR09mK",
    defaultMessage: [{
      "type": 0,
      "value": "Mes outils marketing et mes invitations de parrainage ont été suspendus. Puis-je restaurer l'accès ?"
    }]
  });
  var prefilledSubjectLineMessage = strictLocalize({
    id: "IuPgGV",
    defaultMessage: [{
      "type": 0,
      "value": "Rétablir l'accès aux outils marketing"
    }]
  });
  var emailUsInitial = {
    name: userFullName,
    email: emailAddress,
    subject: queryParams.contact_reason === "invites_suspended" ? prefilledSubjectLineMessage : issuePlaceholder,
    orderNumber: selectedOrderNumber,
    description: queryParams.contact_reason === "invites_suspended" ? prefilledDescriptionMessage : "",
    websiteUrl: ""
  };
  return {
    emailUsInitial: emailUsInitial
  };
};